import { useEffect, useState } from "react";

import { Button, isLoggedIn, Modal } from "@shapr3d/frontend-lib";

import addCommentIcon from "../../assets/images/add-comment-icon.svg";
import { useKeyboardHandle } from "../../hooks/useKeyboardHandle";
import { useMouseHandle } from "../../hooks/useMouseHandle";
import { useCommentsStore } from "../../stores/commentStore";
import { navigateToAuth } from "../../utils/authUtils";
import { ToolButton } from "../ToolButton/ToolButton";

import style from "./Toolbar.module.css";

export const Toolbar = () => {
  const { isInAddCommentMode, toggleIsInAddCommentMode } = useCommentsStore();
  useKeyboardHandle();
  useMouseHandle();

  useEffect(() => {
    if (isInAddCommentMode && !isLoggedIn()) {
      setIsLoginModalOpen(true);
      toggleIsInAddCommentMode({ source: "tool_menu" });
    }
  }, [isInAddCommentMode, toggleIsInAddCommentMode]);

  const handleAddComment = () => {
    if (!isLoggedIn()) {
      setIsLoginModalOpen(true);
    } else {
      toggleIsInAddCommentMode({ source: "tool_menu" });
    }
  };

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return (
    <div className={style.wrapper}>
      <ToolButton
        title="Add Comment (Ctrl+Shift+click)"
        alt="Add Comment"
        icon={addCommentIcon}
        onClick={() => handleAddComment()}
        shouldShowLabel
        isActive={isInAddCommentMode}
        label="Add Comment"
        activeLabel="Place Comment"
      />

      <Modal
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        size="small"
        title="You need to log in to add a comment"
      >
        <div className={style.modalContainer}>
          <div className={style.modalText}>
            You are about to leave this page to log in or sign up.
          </div>
          <Button variant="primary" onClick={() => navigateToAuth()} className={style.button}>
            Log in
          </Button>
        </div>
      </Modal>
    </div>
  );
};
